import { render, staticRenderFns } from "./DiscountFormDialog.vue?vue&type=template&id=466bde3f&scoped=true&"
import script from "./DiscountFormDialog.vue?vue&type=script&lang=js&"
export * from "./DiscountFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./DiscountFormDialog.vue?vue&type=style&index=0&id=466bde3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bde3f",
  null
  
)

export default component.exports